import { FormattedMessage, useIntl } from "react-intl";
import Toast from "common/core-ui/Toast";
import BaseLinkOrButton from "common/core-ui/BaseLinkOrButton";
import styles from "./FacultySurveyToast.module.scss";

interface FacultySurveyToastProps {
  onInteract: () => void;
  href: string;
  onClose?: () => void;
}

export default function FacultySurveyToast({
  onInteract,
  href,
  onClose,
}: FacultySurveyToastProps) {
  const intl = useIntl();

  const title = intl.formatMessage({
    defaultMessage: "Help shape the future of teaching and learning.",
  });

  const body = intl.formatMessage({
    defaultMessage:
      "Join the community of educators making an impact with product research.",
  });

  const handleInteraction = () => {
    onInteract();
    onClose?.();
  };
  return (
    <Toast
      onClose={handleInteraction}
      title={title}
      takeFocus={false}
      startCol={
        <div
          className={styles.thoughtCloud}
          role="img"
          aria-label={intl.formatMessage({ defaultMessage: "Thought Cloud" })}
          // eslint-disable-next-line formatjs/no-literal-string-in-jsx
        >
          💭
        </div>
      }
    >
      <div>{body}</div>
      <div>
        <BaseLinkOrButton
          href={href}
          onClick={handleInteraction}
          className="vst-link"
        >
          <FormattedMessage defaultMessage="Sign Up" />
        </BaseLinkOrButton>
      </div>
    </Toast>
  );
}
